import(/* webpackMode: "eager" */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/error.tsx");
